import { useNavigate } from 'react-router-dom'
import { AlertTitle, Button, Container, Stack, Tooltip } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import reindrift from '../../assets/reindrift.svg'
import { INNSYN_SAVED_PATH } from '../../paths'
import { useInnsynContext } from '../../context/InnsynContextProvider'
import { logIn } from '../../services/LoginService'
import { FormattedMessage } from 'react-intl'
import colors from '../../styles/colors.scss'

export const Search = () => {
    const navigate = useNavigate()
    const { brukerInformasjon, createAlert, konfigurasjon } = useInnsynContext()

    const nameSearchIsDisabled = () => {
        if (!brukerInformasjon) return false
        return !brukerInformasjon.harTilgang

    }

    const getToolTipText = () => {
        if (brukerInformasjon && !brukerInformasjon.harTilgang) {
            return (
                <FormattedMessage id='feilmelding.missing-rights-to-view-name'/>
            )
        }
        return ''
    }

    return (
        <Container sx={{ height: '100%' }}>
            <Stack
                justifyContent={'space-around'}
                flexDirection='column'
                sx={{ height: '100%' }}>
                <img
                    style={{
                        margin: '2rem 0',
                        width: '80%',
                        alignSelf: 'center'
                    }}
                    src={reindrift}
                    alt='reineier'
                />
                <Stack spacing={'1rem'} mb='25px'>
                    <Button
                        onClick={() => navigate('tag')}
                        size='large'
                        sx={{ textAlign: 'left' }}
                        variant='outlined'
                        startIcon={<ArrowForwardIcon/>}>
                        <FormattedMessage id={'search-page.search'}/>
                    </Button>
                    <Tooltip arrow title={getToolTipText()} placement='top'>
                        <Stack>
                            <Button
                                onClick={() => {
                                    brukerInformasjon?.foedselsnummer
                                        ? navigate('name')
                                        : (navigator.onLine && konfigurasjon)
                                            ? logIn(konfigurasjon.altinnUrl)
                                            : createAlert({
                                                body: (
                                                    <>
                                                        <AlertTitle>
                                                            <FormattedMessage id='log-in.alert-no-internet-header'/>
                                                        </AlertTitle>
                                                        <FormattedMessage id='log-in.alert-no-internet'/>
                                                    </>
                                                ),
                                                severity: 'info',
                                                uniqueId: 'log-in-offline'
                                            })
                                }}
                                sx={{ textAlign: 'left' }}
                                disabled={nameSearchIsDisabled()}
                                size='large'
                                variant='outlined'
                                startIcon={
                                    <ArrowForwardIcon
                                        sx={{
                                            color: nameSearchIsDisabled()
                                                ? colors.iconGray
                                                : colors.blue
                                        }}
                                    />
                                }>
                                {brukerInformasjon?.foedselsnummer ? (
                                    <FormattedMessage
                                        id={'name-search.search-name'}
                                    />
                                ) : (
                                    <FormattedMessage
                                        id={'name-search.log-in.search-name'}
                                    />
                                )}
                            </Button>
                        </Stack>
                    </Tooltip>
                    <Button
                        onClick={() => navigate(INNSYN_SAVED_PATH)}
                        size='large'
                        sx={{ textAlign: 'left' }}
                        variant='outlined'
                        startIcon={<ArrowForwardIcon/>}>
                        <FormattedMessage id={'saved-eartags.button-text'}/>
                    </Button>
                </Stack>
            </Stack>
        </Container>
    )
}

export default Search
